import EFPicture from 'elem/compCommon/EFPicture';
import Summer from '@elem/SVGIcon/Homebattery/Summer';
import Winter from '@elem/SVGIcon/Homebattery/Winter';
import Light from '@elem/SVGIcon/PowerBackup/Light';
import Phone from '@elem/SVGIcon/PowerBackup/Phone';
import Refrigerator from '@elem/SVGIcon/PowerBackup/Refrigerator';
import Microwave from '@elem/SVGIcon/PowerBackup/Microwave';
import Dryer from '@elem/SVGIcon/Homebattery/Dryer';
import Fan from '@elem/SVGIcon/OutdoorRecreation/Fan';
import RiceCooker from '@elem/SVGIcon/LoadShedding/RiceCooker';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import gtm from '@/utils/gtm';

const ICON_TV = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_109_5763)">
            <path
                d="M27.5 6H4.5C3.67157 6 3 6.67157 3 7.5V21.5C3 22.3284 3.67157 23 4.5 23H27.5C28.3284 23 29 22.3284 29 21.5V7.5C29 6.67157 28.3284 6 27.5 6Z"
                stroke="#757575"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.5 9H6.5C6.22386 9 6 9.22386 6 9.5V19.5C6 19.7761 6.22386 20 6.5 20H25.5C25.7761 20 26 19.7761 26 19.5V9.5C26 9.22386 25.7761 9 25.5 9Z"
                stroke="#757575"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7 25.7991L8.5 23.201" stroke="#757575" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M25.5 25.7991L24 23.201" stroke="#757575" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_109_5763">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
const ICON_Heater = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_109_5901)">
            <path
                d="M27 22.5L27 9.5C27 8.67157 26.3284 8 25.5 8L22.5 8C21.6716 8 21 8.67157 21 9.5L21 22.5C21 23.3284 21.6716 24 22.5 24L25.5 24C26.3284 24 27 23.3284 27 22.5Z"
                stroke="#757575"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="24" cy="12" r="1" transform="rotate(180 24 12)" fill="#757575" />
            <path
                d="M21 22L21 10C21 8.89543 20.1046 8 19 8C17.8954 8 17 8.89543 17 10L17 22C17 23.1046 17.8954 24 19 24C20.1046 24 21 23.1046 21 22Z"
                stroke="#757575"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17 22L17 10C17 8.89543 16.1046 8 15 8C13.8954 8 13 8.89543 13 10L13 22C13 23.1046 13.8954 24 15 24C16.1046 24 17 23.1046 17 22Z"
                stroke="#757575"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13 22L13 10C13 8.89543 12.1046 8 11 8C9.89543 8 9 8.89543 9 10L9 22C9 23.1046 9.89543 24 11 24C12.1046 24 13 23.1046 13 22Z"
                stroke="#757575"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 22L9 10C9 8.89543 8.10457 8 7 8C5.89543 8 5 8.89543 5 10L5 22C5 23.1046 5.89543 24 7 24C8.10457 24 9 23.1046 9 22Z"
                stroke="#757575"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M24 24L24 26.6667" stroke="#757575" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M25 21H23" stroke="#757575" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M25 18H23" stroke="#757575" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 24L7 26.6667" stroke="#757575" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M9.90155 4.01725L9.52534 4.51516C9.36613 4.72589 9.47503 5.03075 9.73172 5.0929V5.0929C9.99353 5.15628 10.1 5.47079 9.93062 5.68021L9.51765 6.19067"
                stroke="#757575"
                strokeLinecap="round"
            />
            <path
                d="M13.9015 4.01725L13.5253 4.51516C13.3661 4.72589 13.475 5.03075 13.7317 5.0929V5.0929C13.9935 5.15628 14.1 5.47079 13.9306 5.68021L13.5177 6.19067"
                stroke="#757575"
                strokeLinecap="round"
            />
            <path
                d="M17.9015 4.01725L17.5253 4.51516C17.3661 4.72589 17.475 5.03075 17.7317 5.0929V5.0929C17.9935 5.15628 18.1 5.47079 17.9306 5.68021L17.5177 6.19067"
                stroke="#757575"
                strokeLinecap="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_109_5901">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default function F() {
    const { useLang, useState, Link } = useGlobal();
    const { t } = useLang('homebattery');
    const [active, setActive] = useState(0);
    const tabs: string[] = [t('secF_tab1'), t('secF_tab2'), t('secF_tab3')];
    const items: any[] = [
        {
            desc: t.rich('secF_item1_desc', {
                p: (text: string) => <p className="text">{text}</p>,
            }),
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718956868152/f1_1366.jpg',
            imgM: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718956867811/f1_375.jpg',
        },
        {
            desc: t.rich('secF_item2_desc', {
                p: (text: string) => <p className="text">{text}</p>,
            }),
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718956868507/f2_1366.jpg',
            imgM: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718956868329/f2_375.jpg',
        },
        {
            desc: t('secF_item3_desc'),
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718956868858/f3_1366.jpg',
            imgM: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718956868679/f3_375.jpg',
        },
    ];

    const table = [
        [
            {
                icon: <Light className="table-content-icon" />,
                appliance: t('secF_common_table_light'),
                time: t.rich('secF_item1_table_summer_content1', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
            {
                icon: <Light className="table-content-icon" />,
                appliance: t('secF_common_table_light'),
                time: t.rich('secF_item1_table_winter_content1', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
        ],
        [
            {
                icon: <Phone className="table-content-icon" />,
                appliance: t('secF_common_table_phone'),
                time: t.rich('secF_item1_table_summer_content2', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
            {
                icon: <Phone className="table-content-icon" />,
                appliance: t('secF_common_table_phone'),
                time: t.rich('secF_item1_table_winter_content2', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
        ],
        [
            {
                icon: <Refrigerator className="table-content-icon" />,
                appliance: t('secF_common_table_refrigerator'),
                time: t.rich('secF_item1_table_summer_content3', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
            {
                icon: <Refrigerator className="table-content-icon" />,
                appliance: t('secF_common_table_refrigerator'),
                time: t.rich('secF_item1_table_winter_content3', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
        ],
        [
            {
                icon: <Microwave className="table-content-icon" />,
                appliance: t('secF_common_table_wave'),
                time: t.rich('secF_item1_table_summer_content4', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
            {
                icon: <Microwave className="table-content-icon" />,
                appliance: t('secF_common_table_wave'),
                time: t.rich('secF_item1_table_winter_content4', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
        ],
        [
            {
                icon: <RiceCooker className="table-content-icon" />,
                appliance: t('secF_common_table_ricecooker'),
                time: t.rich('secF_item1_table_summer_content5', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
            {
                icon: <RiceCooker className="table-content-icon" />,
                appliance: t('secF_common_table_ricecooker'),
                time: t.rich('secF_item1_table_winter_content5', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
        ],
        [
            {
                icon: <Fan className="table-content-icon" />,
                appliance: t('secF_common_table_fan'),
                time: t.rich('secF_item1_table_summer_content6', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
            {
                icon: <ICON_Heater />,
                appliance: t('secF_common_table_heater'),
                time: t.rich('secF_item1_table_winter_content6', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
        ],
        [
            {
                icon: <Dryer className="table-content-icon" />,
                appliance: t('secF_common_table_hairdryer'),
                time: t.rich('secF_item1_table_summer_content7', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
            {
                icon: <Dryer className="table-content-icon" />,
                appliance: t('secF_common_table_hairdryer'),
                time: t.rich('secF_item1_table_winter_content7', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
        ],
        [
            {
                icon: <ICON_TV />,
                appliance: t('secF_common_table_tv'),
                time: t.rich('secF_item1_table_summer_content8', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
            {
                icon: <ICON_TV />,
                appliance: t('secF_common_table_tv'),
                time: t.rich('secF_item1_table_winter_content8', {
                    s: (text: string) => <span className="s">{text}</span>,
                }),
            },
        ],
    ];

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    const handleClickTab = (k: number, text: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('secF_title'),
            button_name: text,
        });
        setActive(k);
        const target = document.querySelector('.home-battery-F .tabs') as HTMLUListElement;
        if (window.innerWidth < target?.offsetWidth) {
            if (k === 0) {
                target.style.left = '0';
            }
            if (k === 2) {
                target.style.left = `${window.innerWidth - target.offsetWidth}px`;
            }
        }
    };

    return (
        <div id="F" className={`home-battery-F home-battery-box ${css['home-battery-F']}`}>
            <h2 className="title">{t('secF_title')}</h2>
            <div className="tabs-box hidden-scrollbar">
                <ul className="tabs" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: string, k: number) => (
                        <li className={`tab ${k === active ? 'active' : ''}`} key={k} onClick={() => handleClickTab(k, tab)}>
                            {tab}
                        </li>
                    ))}
                </ul>
            </div>
            <ul className="tab-content">
                {items?.map((item: any, k: number) => (
                    <li className={`item ${k === active ? 'active' : ''}`} key={k}>
                        <div className="desc">{item?.desc}</div>
                        <div className="item-info">
                            <div className="item-img">
                                <EFPicture src={item?.img} srcPad={item?.img} srcMobile={item.imgM} alt={item.desc} />
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            <Link
                className="feature-btn"
                href="/delta-pro-3-portable-power-station"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'select_product',
                    list_name: t('secF_title'),
                    product_name: 'EcoFlow DELTA Pro 3',
                    button_name: t('secF_btn'),
                }}
            >
                {t('secF_btn')}
            </Link>
            <p className="table-title">{t('secF_common_table_title')}</p>
            <table border={1} className="item-table">
                <thead className="thead">
                    <tr className="tr">
                        <th className="th td summer">
                            <span className="th-text">{t('secF_common_table_sunmmer')}</span>
                            <span className="th-icon">
                                <Summer />
                            </span>
                        </th>
                        <th className="th td winter">
                            <span className="th-text">{t('secF_common_table_winter')}</span>
                            <span className="th-icon">
                                <Winter />
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody className="tbody">
                    {table.map((row: any, m: number) => (
                        <tr className="tr" key={m}>
                            {row?.map((col: any, n: number) => (
                                <td className={`td ${n === 0 ? 'summer' : 'winter'}`} key={`${m}_${n}`}>
                                    {col?.icon}
                                    <p className="col-time">{col?.time}</p>
                                    <p className="col-appliance">{col?.appliance}</p>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
